export const getPathParts = (path: string) => path.split("/").filter(x => x).map(x => "/" + x);

